import { render, staticRenderFns } from "./ContactBlock.vue?vue&type=template&id=73b497db&lang=pug&"
import script from "./ContactBlock.vue?vue&type=script&lang=js&"
export * from "./ContactBlock.vue?vue&type=script&lang=js&"
import style0 from "./ContactBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports